import { NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'formly-repeat-section',
    template: `
		<div class="row" *ngIf="props.headingText || props.showAddOnTop === true">
			<div class="col-xs-8" *ngIf="props.headingText">
				<h3 class="linq-heading">{{ to.headingText }}</h3>
			</div>
			<div class="col-xs-4" *ngIf="!isDisabled() && props.showAddOnTop === true">
				<button type="button" mat-button color="primary" class="pull-right" (click)="addElement()">
					<mat-icon>add</mat-icon>{{ to.addText }}
				</button>
			</div>
		</div>
		<div *ngFor="let field of field.fieldGroup; let i = index" [attr.class]="'row ' + props.innerRowClass">
			<formly-field class="col" [field]="field"></formly-field>
			<div class="col-sm-2 vertical-center form-field-height" *ngIf="!props.canRemove || props.canRemove(formControl.value)">
				<button *ngIf="!isDisabled()" type="button" mat-icon-button color="warn" (click)="removeElement(i)">
					<mat-icon>delete</mat-icon>
				</button>
			</div>
		</div>
		<div class="clearfix" *ngIf="!isDisabled() && props.showAddOnTop !== true">
			<button
				*ngIf="!props.canAdd || props.canAdd(formControl.value)"
				type="button"
				mat-button
				color="primary"
				class="pull-right"
				(click)="addElement()"
			>
				<mat-icon>add</mat-icon>{{ props.addText }}
			</button>
		</div>
	`,
    standalone: true,
    imports: [
        NgIf,
        MatButtonModule,
        MatIconModule,
        NgFor,
        FormlyModule,
    ],
})
export class FormlyRepeatTypeComponent extends FieldArrayType {
	removeElement(index: number): void {
		this.remove(index);
		if (this.props.removed) {
			this.props.removed(this.field);
		}
	}

	addElement(): void {
		this.add();
		if (this.props.added) {
			this.props.added(this.field);
		}
	}

	isDisabled(): boolean {
		return typeof this.props.disabled === 'boolean' && this.props.disabled === true;
	}
}
